var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid gap-5"},[_c('k-panel',{staticClass:"border"},[_c('p',{staticClass:"leading-7",staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.tranche.details.summary.market))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }